"use strict";

import Global from "/js/core/global.js";
import AppUtil from "/js/util/app-util.js";
import PrimerMaster from "/js/util/primermaster.js";
import CardView from "/js/card-views/card-view.js";
import Strings from "/js/util/strings.js";

/**
 * Lesson cover card.
 */
export default class CoverCardView extends CardView {

  static TEMPLATE_STRING_P4W_STYLE = `
    <div class='circle <%=circleColorClass%>'></div>
    <img class='img' src='<%= featureImage %>' alt="">
    <div class='title'><%= title %></div>
    <div class='creditP4wStyle'><span><%=creditLine%></span></div>`;
  static templateP4wStyle = _.template(CoverCardView.TEMPLATE_STRING_P4W_STYLE);

  static TEMPLATE_STRING_APP_STYLE = `
    <div class='circle <%=circleColorClass%>'></div>
    <img class='img' src='<%= featureImage %>' alt="">
    <div class='title'><%= title %></div>
    
    <div class='skillLabel'><%=skillLabel%></div>
    <div class='skillName'><img class="skillIcon" src="<%=skillIconPath%>"><div class="skillText"><%=skillName%></div></div>
    <div class='bottomStroke'></div>
    <div class='creditAppStyle'><span><%=creditLine%></span></div>
    <div class='durationIcon'></div><div class="duration"><%=duration%></div>
    `;
  static templateAppStyle = _.template(CoverCardView.TEMPLATE_STRING_APP_STYLE);

  makeContent(explicitSkillId=null) {

    const lessonId = Global.lessonId;

    let skill;
    let shouldUseAppStyle;
    if (explicitSkillId) {
      shouldUseAppStyle = true;
      skill = PrimerMaster.getSkillById(explicitSkillId);
    } else {
      shouldUseAppStyle = false;
      skill = PrimerMaster.getSkillForLessonId(lessonId);
    }

    // Start with the existing card data, and add extra properties to also be used by template.
    const o = _.clone(this.data);
    
    // Cover card image path
    o.featureImage = AppUtil.makeFeatureImagePath(lessonId);

    // Circle color class
    o.circleColorClass = skill ? PrimerMaster.getBgColorClassForSkill(skill.id) : '';

    const creditString = Strings.get("lesson_credit");
    o.creditLine = creditString.replace("%1$s", this.data.credit);

    if (shouldUseAppStyle) {
      // Skill label, skill icon, skill name, and duration
      let s = skill ? skill.id : "empty";
      s = s.replace("-", "_");
      o.skillIconPath = "img/lesson/icon_" + s + ".png";
      o.skillLabel = Strings.get("generic_skill_singular");
      o.skillName = skill ? skill.label : "";
      o.duration = Global.lessonData.meta.duration || "";
    }

    const result = shouldUseAppStyle
        ? CoverCardView.templateAppStyle(o)
        : CoverCardView.templateP4wStyle(o);
    return result;
  }
}
